<template>
  <div class="laporan" :class="{ 'animate-flicker': loading }">
    <div>
      <h2>Paid In / Paid Out</h2>

      <br />

      <div class="filter">
        <div class="form-group">
          <label for="">Filter Tanggal</label>
          <date-range-picker v-model="dateRange">
            <template v-slot:input="picker">
              {{ moment(picker.startDate).format("DD MMM YYYY") }} -
              {{ moment(picker.endDate).format("DD MMM YYYY") }}
            </template>
          </date-range-picker>
        </div>
        <div class="form-group">
          <label>&nbsp;</label>
          <button type="button" class="btn-fill" @click="loadData">
            Filter
          </button>
        </div>
        <div></div>
        <div class="form-group">
          <label>Export Data</label>
          <button type="button" class="btn-outline green" @click="exportExcel()">Export Excel</button>
        </div>
      </div>

      <table class="table">
        <thead>
          <tr>
            <th style="width: 50px">No</th>
            <th>Tanggal</th>
            <th>Keterangan</th>
            <th>Jumlah</th>
            <th>Tipe</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="index">
            <td>{{ ++index }}</td>
            <td>{{ moment(item.tanggal).format("DD/MM/YYYY") }}</td>
            <td>{{ item.nama }}</td>
            <td>{{ item.jumlah | number }}</td>
            <td>{{ item.tipe }}</td>
          </tr>
        </tbody>
      </table>

      <div>
        <h3>Total</h3>
        <table>
          <tr>
            <td><b>Paid IN</b></td>
            <td>&nbsp;</td>
            <td align="right">
              <b>{{ total.paidIn | number }}</b>
            </td>
          </tr>
          <tr>
            <td><b>Paid OUT</b></td>
            <td></td>
            <td align="right">
              <b>{{ total.paidOut | number }}</b>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import * as api from "../../api/Api";
import moment from "moment";

export default {
  components: {
    DateRangePicker,
  },
  name: "Menu Favorit",
  data() {
    return {
      loading: false,
      data: [],
      dateRange: {
        startDate: moment().format("YYYY-MM-01"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      filter: {
        id_toko: this.$toko.id,
        tgl_awal: moment().format("YYYY-MM-01"),
        tgl_akhir: moment().format("YYYY-MM-DD"),
      },
      total: {
        paidIn: 0,
        paidOut: 0,
      },
    };
  },
  methods: {
    moment,
    loadData() {
      this.loading = true;

      this.filter.tgl_awal = moment(this.dateRange.startDate).format(
        "YYYY-MM-DD"
      );
      this.filter.tgl_akhir = moment(this.dateRange.endDate).format(
        "YYYY-MM-DD"
      );

      api
        .get("/v4/paid-in-out?" + this.$objectToQuery(this.filter))
        .then((r) => {
          this.loading = false;
          this.data = r.data;

          this.data.forEach((item) => {
            if (item.tipe.toUpperCase() == "IN") {
              this.total.paidIn += parseInt(item.jumlah);
            } else {
              this.total.paidOut += parseInt(item.jumlah);
            }
          });
        })
        .catch((e) => {
          this.loading = false;
          this.openFilter = false;
        });
    },
    exportExcel() {
      this.loadingExcel = true;
      const payload = this.data;

      const tgl_awal = moment(this.dateRange.startDate).format("YYYY-MM-DD");
      const tgl_akhir = moment(this.dateRange.endDate).format("YYYY-MM-DD");

      api
        .postJson(
          "https://app.restoku.id/exporter/paidInOut?id_toko=" +
            this.$toko.id +
            "&title=Laporan Paid In - Paid Out" +
            "&tgl_awal=" +
            tgl_awal +
            "&tgl_akhir=" +
            tgl_akhir,
          payload
        )
        .then((r) => {
          if (r.valid) {
            location.href = r.url;
          }

          this.loadingExcel = false;
        })
        .catch((e) => {
          this.$toast("Terjadi kesalahan");
          this.loadingExcel = false;
        });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped lang="scss">
.laporan {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
  }

  .filter {
    display: grid;
    grid-template-columns: 240px 150px 1fr 150px;
    grid-column-gap: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #ccc;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/laporan/PaidInOut.vue